@if (category(); as c) {
    <div
        cdkDrag
        cdkDragPreviewClass="shadow-xl"
        class="flex gap-3 justify-between items-center px-4 py-2 w-full select-none bg-gray-50 rounded-xl"
    >
        <div
            cdkDragHandle
            class="cursor-move visible flex justify-center items-center bg-gray-50 rounded-full"
        >
            <app-icon
                name="material-symbols:menu-rounded"
                class="!size-5 text-gray-400"
            />
        </div>
        <div class="flex w-full justify-between items-center">
            @if (isUpdate()) {
                <app-product-category-form
                    (cancel)="cancel()"
                    (submit)="submit()"
                    class="w-full"
                    [(value)]="formValue"
                />
            } @else {
                <p class="text-gray-800">{{ c.name }}</p>
                <app-icon-button
                    [cdkMenuTriggerFor]="menu"
                    icon="mdi:dots-vertical"
                    class="text-gray-700"
                />
            }
        </div>
    </div>
}

<ng-template #menu>
    <app-menu cdkMenu>
        <app-menu-option (click)="handleUpdate()" cdkMenuItem
            >수정</app-menu-option
        >
        <app-menu-option (click)="handleDelete()" cdkMenuItem
            >삭제</app-menu-option
        >
    </app-menu>
</ng-template>
